<template>
  <v-dialog v-model="dialogLocal" max-width="450px" persistent>
    <v-card>
      <v-card-title class="headline-custom" style="font-size: 1.3rem !important; hyphens: auto">
        Configurar consulta
        <br />
        <strong>{{ data.nome }}</strong>
      </v-card-title>
      <v-card-text style="font-size: 15px !important">
        <v-row class="align-center justify-left">
          <v-col cols="6">
            <v-switch v-model="isInterna" class="px-3">
              <template #label>
                <v-tooltip top color="transparent" max-width="600" content-class="custom-tooltip">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" class="info-text" v-on="on">
                      Interna
                      <v-icon small class="ml-1">mdi-information</v-icon>
                    </div>
                  </template>
                  <v-alert border="top" colored-border type="info" elevation="2" class="text-justify">
                    Consultas Internas são criadas somente para alimentar outras ferramentas do sistema, como por exemplo,
                    gráficos para dashboards. Elas ficarão escondidas nas telas de listagens de consultas do sistema, mas poderão
                    ser facilmente encontradas através dos filtros presentes nessas telas.
                  </v-alert>
                </v-tooltip>
              </template>
            </v-switch>
          </v-col>
          <v-col cols="6">
            <v-switch v-model="isDashboard" class="px-3">
              <template #label>
                <v-tooltip color="transparent" top max-width="600" content-class="custom-tooltip">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" class="info-text" v-on="on">
                      Dashboard
                      <v-icon small class="ml-1">mdi-information</v-icon>
                    </div>
                  </template>
                  <v-alert border="top" colored-border type="info" elevation="2" class="text-justify">
                    Consultas Dashboard são criadas para alimentar os dashboards do Hexa-V2.
                  </v-alert>
                </v-tooltip>
              </template>
            </v-switch>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn color="green darken-1" text @click="dialogLocal = false">Fechar</v-btn>
        <v-btn color="green darken-1" @click="modificar">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import RelatoriosService from '@/services/RelatoriosService';

  export default {
    components: {},
    mixins: [],

    props: {
      dialog: {
        type: Boolean,
        required: true
      },
      data: {
        type: Object,
        required: true
      }
    },

    emits: ['submitTriggered', 'update:dialog'],

    data: () => ({
      isInterna: false,
      isDashboard: false
    }),

    computed: {
      dialogLocal: {
        get() {
          return this.dialog;
        },
        set(newValue) {
          this.$emit('update:dialog', newValue);
        }
      }
    },

    mounted() {
      this.fetchConsultaInterna();
    },

    methods: {
      fetchConsultaInterna() {
        RelatoriosService.getConsultaInterna(this.data.id)
          .then(({ data }) => {
            this.isInterna = data.interna;
            this.isDashboard = data.dashboard;
          })
          .catch((error) => {
            this.$toast.error('Erro ao buscar status de consulta interna');
            console.log(error);
          });
      },

      modificar() {
        this.$emit('submitTriggered', {
          id: this.data.id,
          status: {
            interna: this.isInterna,
            dashboard: this.isDashboard
          }
        });
      }
    }
  };
</script>

<style scoped>
  .custom-tooltip {
    opacity: 1 !important;
  }

  .info-text {
    display: flex;
    align-items: center;
  }
</style>
